<template>
  <f7-popup :color-theme="themeColor">
    <f7-page>
      <f7-navbar title="退款">
        <f7-nav-right>
          <f7-link @click="getNewQrCode">
            <font-awesome-icon icon="sync-alt" />
          </f7-link>
          <f7-link popup-close>
            <font-awesome-icon icon="times" />
          </f7-link>
        </f7-nav-right>
      </f7-navbar>
      <div style="display: flex; align-items: center; justify-content: center; flex-direction:column; margin: 30px;">
        <qr-code v-if="qrCode" :text="qrCode" :size="qrCodeWidth" level="H" />
        剩餘時間: {{ timerString }}
      </div>
    </f7-page>
  </f7-popup>
</template>

<script>
import QrCode from '@/common/components/QrCode'
import { mapState } from 'vuex'
import moment from 'moment'
import { storeClient } from '@/service/apiClients'

export default {
  name: 'SpecialRequestsPopup',
  dependencies: ['themeColor'],
  data () {
    return {
      qrCode: null,
      windowWidth: 0,
      windowHeight: 0,
      expiresIn: 5,
      expireMoment: null,
      timerString: '',
      timerIntervalId: null
    }
  },
  created () {
    this.getNewQrCode()
    this.timerIntervalId = setInterval(() => {
      const duration = moment.duration(this.expireMoment.diff(moment()))
      if (duration.seconds() >= 0) {
        this.timerString = duration.minutes() + ' 分 ' + duration.seconds() % 60 + ' 秒'
      }
    }, 1000)
  },
  beforeDestroy () {
    clearInterval(this.timerIntervalId)
  },
  mounted () {
    this.$nextTick(function () {
      window.addEventListener('resize', this.getWindowWidth)
      window.addEventListener('resize', this.getWindowHeight)

      // Init
      this.getWindowWidth()
      this.getWindowHeight()
    })
  },
  props: {
    storeIdProp: String,
    orderIdProp: String
  },
  computed: {
    ...mapState('orderModule', ['channels']),
    qrCodeWidth () {
      // TODO 這邊還要經過實際測試才知道最大可以多大，目的是不要讓 qrcode 超過 scanner
      return Math.min(300, this.windowWidth * 0.6)
    },
    moment () { return moment }
  },
  methods: {
    getWindowWidth (event) {
      this.windowWidth = document.documentElement.clientWidth
    },
    getWindowHeight (event) {
      this.windowHeight = document.documentElement.clientHeight
    },
    async getNewQrCode () {
      const result = await storeClient.post(`/stores/${this.storeIdProp}/orders/${this.orderIdProp}/refundingToken`)
      this.qrCode = result.data
      this.expireMoment = moment().add(this.expiresIn, 'm')
    }
  },
  components: {
    QrCode
  }
}
</script>
